export default "__VITE_ASSET__Bqtgnszc__"